import fuzzyLogicSoilAttribute from './fuzzyLogicSoilAttribute';

export const MECH_SITE_PREP_DEEP = fuzzyLogicSoilAttribute({
  fuzzyLogicRuleName: 'FOR - Mechanical Site Preparation (Deep)',
  key: 'Mechanical Site Preparation (Deep)',
  ruleId: '45',
  shortFormData: { AggregationMethod: 'Dominant Condition' },
});
